/* eslint react/prop-types: 0 */

import React from "react";
import { graphql } from "gatsby";
import Layout from "../components/layout";
import SEO from "../components/seo";
import Img from "gatsby-image";
function IndexPage({ data }) {
  return (
    <Layout>
      <SEO
        keywords={[`gatsby`, `tailwind`, `react`, `tailwindcss`]}
        title="Family out now"
      />

      <section className="flex flex-col w-full flex-wrap justify-center items-center text-center content-center">
        <div className="center">
          <button className="bg-green-600 hover:bg-green-700 text-white font-bold py-2 px-4 rounded">
            <a href="https://tingsek.lnk.to/family">Listen now!</a>
          </button>
        </div>
        <div className="md:w-2/3 w-full p-8">
          <Img fluid={data.allFile.edges[0].node.childImageSharp.fluid} />
        </div>
      </section>
    </Layout>
  );
}

export const query = graphql`
  {
    allFile(filter: { name: { eq: "cover" } }) {
      edges {
        node {
          childImageSharp {
            fluid(maxWidth: 800, quality: 80) {
              ...GatsbyImageSharpFluid_withWebp
            }
          }
        }
      }
    }
  }
`;

export default IndexPage;
